import { useEffect, useState, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { addDoc, collection, doc, getDoc, query, where, getDocs, deleteDoc } from 'firebase/firestore';
import { useAuth } from '../../../providers/auth-provider';
import { db } from '../../../firebase-config';
import { Button } from '@mui/material';
import AppButton from '../../Common/AppButton';
import { TournamentStatus } from '../../utils';
import { BASE_URL, COMPLETED_TOURNAMENTS_BASE_URL, DEFAULT_NEGATIVE_SCORE, DEFAULT_POSIIVE_SCORE, DEMO_BASE_URL, ENABLE_SKIP_LS_KEY, NEGATIVE_SCORE_LS_KEY, NEW_FORMAT_TOURNAMENT_GAMES, POSITIVE_SCORE_LS_KEY } from '../../../Constants/Commons';
import ArenaHeader from '../../../GamesArena/Common/ArenaHeader';
import axios from 'axios';
import Loader from '../Loader';
import mixpanel from 'mixpanel-browser';
import useToast from '../../../hooks/use-toast';


const PostTournamentPractice = () => {
    const { user } = useAuth();
    let roundFormat = '';
    const { ToastComponent, showToast } = useToast();

    const [searchParams,] = useSearchParams();
    const [selectedRound, setSelectedRound] = useState(null);
    const tId = searchParams.get("tid");

    const [allRoundData, setAllRoundData] = useState([]);
    const [tournamentData, setTournamentData] = useState({});
    const [isButtonLoading, setLoading] = useState(false);
    const [loadingButtonIndex, setLoadingButtonIndex] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isTournamentDataLoading, setIsTournamentDataLoading] = useState(true);
    const [toastMessage, setToastMessage] = useState(
        "You have already played this round. Please wait for the next round to start."
    );
    const [roundScores, setRoundScores] = useState([]);
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();
    const isDemoGame = searchParams.get("d") === "Y";
    const group = searchParams.get("group");

    const fetchRoundDetails = async (tData) => {
        const rounds = [];
        for (let i = 1; i <= +tData.activeRound; i++) {
            let tournamentId = tData.id;
            if (tData.eliminationFinal && (i == 1 || i == 2)) {
                const poolIds = tData.poolIds;
                tournamentId = poolIds.find((p) => user?.registrations.includes(p));
                if (!tournamentId || tournamentId === tData.id) {
                    tournamentId = poolIds[0];
                }
            }
            let data = await getSingleRoundData(i, tournamentId);
            data = { ...data, tournamentId: tournamentId, round: i };
            rounds.push(data);
        }
        setAllRoundData(rounds);
    };

    useEffect(() => {
        const fetchTournamentData = async () => {
            const dataRef = doc(db, "tournaments", tId);
            const dataSnap = await getDoc(dataRef);
            setTournamentData({ ...dataSnap.data(), id: tId });
            fetchRoundDetails({ ...dataSnap.data(), id: tId });
            setIsTournamentDataLoading(false);
        };

        const fetchRoundScores = async () => {
            const response = await axios.post(`${process.env.REACT_APP_NODE_BASE_URL}/tournamentPractice/get-round-scores`, {
                tournamentId: tId,
                childId: user.id,
                tenantStatus: user.tenantStatus,
            });
            setIsLoading(false);
            setRoundScores(response.data.data);
        };



        fetchTournamentData();
        fetchRoundScores();
    }, [tId]);


    const getSingleRoundData = async (activeRound, tournamentId) => {
        const dataRef = doc(db, `tournaments/${tournamentId}/rounds`, String(activeRound));
        const dataSnap = await getDoc(dataRef);
        return dataSnap.data();
    };

    const playGame = async (tId, activeRound, isWeeklyQuiz = false, isPractice = false, isQuiz = false, scoreToBeat) => {
        const data = [];

        checkIfRoundIsActive(tId, activeRound, isPractice).then((status) => {
            if (status) {
                localStorage.setItem("tournamentID", tId);
                localStorage.setItem("roundFormat", roundFormat);
                localStorage.setItem("isWeeklyQuiz", isWeeklyQuiz);
                localStorage.setItem("isQuiz", isQuiz);
                localStorage.setItem("childId", user.id);
                localStorage.setItem("scoreToBeat", scoreToBeat);
                initialiseGame(tId, roundFormat, activeRound);
            } else {
                setToastMessage(
                    "This round is not active. Please wait for a round to begin."
                );
                setOpen(true);
            }
        });
    };

    const initialiseGame = (tournamentId, roundFormat = "", activeRound) => {
        const headers = new Headers();
        headers.append("Content-Type", "application/json");
        //myHeaders.append("Access-Control-Allow-Origin", "*");
        const localStorageChildId = localStorage.getItem("userId");

        const roundBaseDifficulty = localStorage.getItem("baseDifficulty");
        const body = JSON.stringify({
            childId: localStorageChildId,
            playerName: localStorageChildId,
            tournamentId,
            roundId: activeRound,
            group: (isDemoGame && group) ? group : undefined,
        });

        let requestOptions = {
            method: "POST",
            headers,
            body,
        };

        const url = COMPLETED_TOURNAMENTS_BASE_URL;
        fetch(`${url}/initialize`, requestOptions)
            .then((response) => {
                if (response.status >= 400) window.location.href = "/error";
                else {
                    return response.text();
                }
            })
            .then((result) => {
                let url = `/quiz/tournament?tId=${tournamentId}&rF=${roundFormat}&r=${activeRound}`;

                // localStorage.setItem("gId", result);

                if (NEW_FORMAT_TOURNAMENT_GAMES.includes(roundFormat)) {
                    if (roundBaseDifficulty === 6) {
                        url = `/quiz/newFormatGame?tId=${tournamentId}&rF=${roundFormat}&r=${activeRound}&pro=Y`;
                    } else {
                        url = `/quiz/newFormatGame?tId=${tournamentId}&rF=${roundFormat}&r=${activeRound}`;
                    }
                }
                url += `&pt=Y&gId=${result}`;
                navigate(url);
            })
            .catch((error) => {
                window.location.href = "/error";
            });
    };

    const checkIfRoundIsActive = async (tId, activeRound, isPractice = false) => {
        // const round = await FB.getData(
        //     `tournaments/${tId}/rounds`,
        //     String(activeRound)
        // );   
        const round = await getSingleRoundData(activeRound, tId);
        if (round) {
            roundFormat = round.format;
            // const roundS = TournamentStatus(
            //     round.startDate.seconds,
            //     round.endDate.seconds
            // );
            const { roundCTA, roundInitImage, roundFact, phasePattern, baseDifficulty, roundDuration, roundsPerQuestion } = round;
            //remove roundInfo from local storage
            localStorage.removeItem("roundInfo");
            if (roundCTA && roundInitImage) {
                localStorage.setItem(
                    "roundInfo",
                    JSON.stringify({ roundCTA, roundInitImage, roundFact })
                );
            }
            localStorage.setItem("roundDuration", roundDuration);
            localStorage.setItem("roundTitle", round.title);
            localStorage.setItem("keyboardType", round.keyboardType);
            localStorage.setItem("assertionLogic", round.assertionLogic);
            localStorage.setItem("quizColl", round.quizCollection);
            localStorage.setItem(POSITIVE_SCORE_LS_KEY, round.positiveScore ?? DEFAULT_POSIIVE_SCORE);
            localStorage.setItem(NEGATIVE_SCORE_LS_KEY, round.negativeScore ?? DEFAULT_NEGATIVE_SCORE);
            localStorage.setItem(ENABLE_SKIP_LS_KEY, round.enableSkip ?? false);
            localStorage.setItem("roundsPerQuestion", roundsPerQuestion);
            if (phasePattern?.[1]) {
                localStorage.setItem("roundDifficultyPattern", phasePattern?.[1]);
            }
            localStorage.setItem("baseDifficulty", baseDifficulty);

            // if (roundS === "ONGOING" || isPractice) return true;
            // else return false;
            return true;
        } else {
            return false;
        }
    };

    const handlePlayRound = async (index) => {
        mixpanel.identify(user.id);
        mixpanel.track('completed_roundPlay', {
            tournamentId: allRoundData[index].tournamentId,
            roundId: allRoundData[index].round,
        });
        if (index === 2 && !roundScores[`${index + 1}`]?.eligibleForFinal || loadingButtonIndex != null) {
            showToast("Beat the R1 + R2 target score to unlock");
            return;
        }
        setLoadingButtonIndex(index);
        let scoreToBeat = 0;
        scoreToBeat = roundScores[`${index + 1}`] ?? 0;
        if (index == 2) {
            scoreToBeat = Math.max(
                roundScores[`${index + 1}`]?.bestRankedScore,
                roundScores[`${index + 1}`]?.bestSelfScore
            );
        }
        await playGame(allRoundData[index].tournamentId, allRoundData[index].round, false, false, false, scoreToBeat);
    }

    const handleBack = () => {
        navigate("/completed-tournament-practice-lobby");
    };

    const getBgColor = (index) => {
        if (index == 0) {
            return '#0E893E';
        }
        else if (index == 1) {
            return '#FF5050';
        }
        else if (index == 2) {
            return '#156EC0';
        }
    };

    return (
        <div className='h-full w-full overflow-auto flex flex-col justify-start gap-4'>
            <ArenaHeader
                goBack={handleBack}
                headerText={tournamentData.name}
                nonArenaRoute={true}
            />
            {/* content */}

            {(isLoading || isTournamentDataLoading) ? (
                <div className='flex items-center justify-center h-full w-full'>

                    <Loader />
                </div>
            ) : (

                <div className='flex flex-col items-center gap-4 '>
                    {tournamentData.module && <div className='flex items-center justify-between w-[85vw] bg-[#5a5a5a] rounded-lg p-2'>
                        <span className='text-white'>Revise concepts</span>
                        <AppButton
                            className=' min-w-[80px]'
                            onClick={() => {
                                navigate(`/practice-arena-learn?tid=${tournamentData.module}&back=completed-tournament-practice?tid=${tournamentData.id}`);
                            }}
                            variant="rectangularPrimary"
                        >
                            Revise
                        </AppButton>
                    </div>}
                    {allRoundData.map((round, index) => {
                        const bgColor = index === 0
                            ? '#0E893E'
                            : index === 1
                                ? '#FF5050'
                                : index === 2
                                    ? '#156EC0'
                                    : 'transparent';

                        return (
                            <div
                                key={index}
                                className="flex flex-col gap-2 w-[85vw] h-[140px] rounded-xl shadow-[0_0_0_1px_rgba(255,255,255,0.3)]"
                                style={{ backgroundColor: bgColor }}
                            >
                                <span className="text-white text-lg font-bold text-start m-2">
                                    Round {index + 1} - {round.title}
                                </span>

                                {index !== 2 ? (
                                    <div className="flex items-end w-full h-[20px] px-2 text-[16px] text-white">
                                        <span>
                                            Target Score:&nbsp;

                                            <span
                                                style={{
                                                    fontFamily: '"Avenir Heavy", sans-serif',
                                                    fontSize: "16px",
                                                }}
                                            >
                                                {roundScores[`${index + 1}`]}
                                            </span>
                                        </span>
                                    </div>

                                ) : (
                                    <div className="flex flex-col items-start justify-start w-full h-[40px] px-2 mt-auto text-[16px] text-white">
                                        {roundScores[`${index + 1}`]?.eligibleForFinal ? (

                                            <span>
                                                Target Score:&nbsp;
                                                <span
                                                    style={{
                                                        fontFamily: '"Avenir Heavy", sans-serif',
                                                        fontSize: "16px",
                                                    }}
                                                    className="text-[18px] font-bold">
                                                    {Math.max(
                                                        roundScores[`${index + 1}`]?.bestRankedScore,
                                                        roundScores[`${index + 1}`]?.bestSelfScore
                                                    )}
                                                </span>
                                            </span>
                                        ) : (
                                            <>
                                                <span>
                                                    Target Score (R1+R2):&nbsp;
                                                    <span
                                                        style={{
                                                            fontFamily: '"Avenir Heavy", sans-serif',
                                                            fontSize: "16px",
                                                        }}
                                                        className="text-[18px]">
                                                        {roundScores[`${index + 1}`]?.scoreToQualifyForFinal}
                                                    </span>
                                                </span>
                                                <span>
                                                    Personal Best:&nbsp;
                                                    <span
                                                        style={{
                                                            fontFamily: '"Avenir Heavy", sans-serif',
                                                            fontSize: "16px",
                                                        }}
                                                        className="text-[18px]">
                                                        {roundScores[`${index + 1}`]?.hasPlayedQualifiers ? roundScores[`${index + 1}`]?.qualifiersBestSelfScore : "-"}
                                                    </span>
                                                </span>
                                            </>
                                        )}
                                    </div>
                                )}

                                <div className="flex items-center justify-center w-full h-[40px] px-4  pb-2 mt-auto">
                                    <AppButton
                                        className='w-[130px]'
                                        onClick={() => handlePlayRound(index)}
                                        locked={index === 2 && !roundScores[`${index + 1}`]?.eligibleForFinal && loadingButtonIndex !== index}
                                        unlocked={index === 2 && roundScores[`${index + 1}`]?.eligibleForFinal && loadingButtonIndex !== index}
                                        isLoading={loadingButtonIndex === index}
                                        progressSize={20}
                                        disabled={loadingButtonIndex === index}
                                    >PLAY</AppButton>

                                </div>
                                <ToastComponent />
                            </div>

                        );
                    })}

                </div>)}
        </div>
    )
}

export default PostTournamentPractice;